import { concatMiddleware } from 'botframework-webchat-component';
import { throttled } from '../util/throttled';
import { onChatHistoryLoadedMiddleware } from './onChatHistoryLoadedMiddleware';
import { onUserActionMiddleware } from './onUserActionMiddleware';
const onActivityKey = {};
const onExpiredKey = {};
export function sessionMiddlewareFactory(config) {
    if (config.idleTimeoutMS <= 0) {
        return;
    }
    let isExecuting = false;
    let timeout;
    const callbacks = new WeakMap();
    const keepAlive = throttled((...args) => {
        var _a;
        if (timeout)
            clearTimeout(timeout);
        timeout = setTimeout(() => {
            var _a;
            if (!isExecuting) {
                isExecuting = true;
                try {
                    (_a = callbacks.get(onExpiredKey)) === null || _a === void 0 ? void 0 : _a(...args);
                }
                finally {
                    isExecuting = false;
                }
            }
        }, config.idleTimeoutMS);
        if (!isExecuting) {
            isExecuting = true;
            try {
                (_a = callbacks.get(onActivityKey)) === null || _a === void 0 ? void 0 : _a(...args);
            }
            finally {
                isExecuting = false;
            }
        }
    }, config.activityThrottleMS || 5000);
    return {
        onActivity: (cb) => {
            callbacks.set(onActivityKey, cb);
        },
        onExpired: (cb) => {
            callbacks.set(onExpiredKey, cb);
        },
        middleware: concatMiddleware(onChatHistoryLoadedMiddleware(keepAlive), onUserActionMiddleware(keepAlive)),
        destroy: () => {
            if (timeout)
                clearTimeout(timeout);
            callbacks.delete(onActivityKey);
            callbacks.delete(onExpiredKey);
        }
    };
}
//# sourceMappingURL=sessionMiddleware.js.map